"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyPortDirectionEnum = void 0;
var JourneyPortDirectionEnum;
(function (JourneyPortDirectionEnum) {
    JourneyPortDirectionEnum["Input"] = "input";
    JourneyPortDirectionEnum["Output"] = "output";
})(JourneyPortDirectionEnum = exports.JourneyPortDirectionEnum || (exports.JourneyPortDirectionEnum = {}));
